import axiosClient from "./axios";
import { GET_ALL_SHOPS } from "../constants/endpoints";

class shopService {
  static async fetchAllShops(
    currentPage: number,
    itemsPerPage: number,
    category: string,
    isActive: boolean,
    isOpen: boolean,
    delivery: boolean,
    shopName: string
  ) {
    const filters = {
      category: category !== null ? category : undefined,
      isActive: isActive !== null ? isActive : undefined,
      isOpen: isOpen !== null ? isOpen : undefined,
      delivery: delivery !== null ? delivery : undefined,
      shopName: shopName !== null ? shopName : undefined,
    };
    const response = await axiosClient.post(GET_ALL_SHOPS, {
      page: currentPage,
      limit: itemsPerPage,
      filters: filters,
    });
    return response;
  }

  static async fetchAllShopsForLogin() {
    // Fetch all shops without pagination for login purposes
    const response = await axiosClient.post(GET_ALL_SHOPS, {
      page: 1,
      limit: 100,
      filters: {},
    });
    return response;
  }
}
export default shopService;
